import Vuex from 'vuex'
import Vue from 'vue'
import vuexI18n from 'vuex-i18n'

import vux from './modules/vux'
import app from './modules/app'
import user from './modules/user'
import vc from './modules/vc'

import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    vux,
    app,
    user,
    vc,
    i18n: vuexI18n.store
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js